<template>
  <div>
    <card class="card-stats vital-card">
      <div class="statistics statistics-horizontal">
        <div class="info info-horizontal">
          <div class="row" v-if="!vitalGroup">
            <div class="col-12">
              <h5 class="info-title text-left vital-name" style="font-weight: 500; font-size: 1rem">
                {{ deviceforcard.displayName[$i18n.locale] ||  deviceforcard.displayName['en-US']}}
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-2 pt-2" v-for="vital in vitals" :key="vital.identifier">
              <div class="row" style="margin-top: 1em;">
                <div class="col-4 pr-0" style="display: flex;flex-direction: column;" v-if="vital.icon && vital.icon.assetName">
                  <div class="icon icon-circle mb-4 pb-4 ml-0" style="width: 4.5em;height: 4.5em;text-align: center;background-color: #f9f8f8;box-shadow:none" :class="`icon-info`">
                    <img class="device-vital-image" :src="require('@/assets/img/vitals/' + vital.icon.assetName)" />
                  </div>
                  <div>
                    {{ vital.displayName[$i18n.locale] || vital.displayName['en-US'] }}
                  </div>
                </div>

                <div class="col-8">
                  <line-chart v-if="dataForGraph[vital.identifier] && dataForGraph[vital.identifier].labels && dataForGraph[vital.identifier].labels.length > 0 && dataForGraph[vital.identifier].datasets.length > 0" :datasets="dataForGraph[vital.identifier].datasets" :height="150" :labels="dataForGraph[vital.identifier].labels" :color="color"></line-chart>

                  <div v-if=" dataForGraph[vital.identifier] && dataForGraph[vital.identifier].labels && dataForGraph[vital.identifier].labels.length < 1">
                    <img src="@/assets/img/graph.png" style="opacity: 0.3; height: 7em; width: 100%" />
                    <div style="position: absolute; top: 3em; width: 100%" class="text-center">
                      {{ $t("message.Not enough vitals to plot") }}
                    </div>
                  </div>
                  <div v-if="dataForGraph[vital.identifier] && dataForGraph[vital.identifier].datasets.length < 1">
                    <div class="indicator">
                      <svg width="16px" height="12px">
                        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6" />
                        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6" />
                      </svg>
                    </div>
                  </div>
                </div>

                <n-button type="primary" style="position: absolute;right: 0.8em;top: -1em;" social icon round size="sm" v-if="!IS_HEALTHKIT && deviceforcard && deviceforcard.communication && deviceforcard.communication.fetchPerVital && !vitalGroup && allowRetrieval" @click.native="addVitals(vital)">
                  <i class="fas fa-plus"></i>
                </n-button>
              </div>

              <div class="row" v-if="allowManualEntry">
                <div class="col-8">
                  <input class="form-control" type="number" v-model="vital.value" style="padding-top: 10px" :placeholder="vital.displayName[$i18n.locale] || vital.displayName['en-US']" :disabled="disableInputs" />
                </div>
                <div class="col-4">
                  <div style="position: absolute; top: 1em;">
                    {{ vital.unit.primary }}
                  </div>
                </div>
              </div>

              <!-- Error Message -->
              <div class="row" v-if="
                errorMessages[vital.identifier] &&
                errorMessages[vital.identifier].length > 0
              ">
                <div class="col-12 text-danger">
                  {{ $t("message.Invalid") }}
                </div>
              </div>
            </div>
            <div style="display: flex;width: 100%;justify-content: end;">
            <n-button v-if="
              !IS_HEALTHKIT &&
              deviceforcard && deviceforcard.communication && !deviceforcard.communication.fetchPerVital &&
              connectedDevicesEnabled &&
              deviceforcard.communication.communicationType != 'MANUAL' &&
              deviceforcard.communication.communicationType != 'OCR' && allowRetrieval
            " type="primary" @click.native="retrieveVital(deviceforcard)" social icon round style="position: absolute; top: -1em; inset-inline-end: -0.5em">
              <i class="fa" :class="
                deviceforcard.communication.communicationMethod == 'FETCH'
                  ? 'fa-arrow-down'
                  : !deviceforcard.FETCHING
                  ? 'fa-record-vinyl'
                  : 'fa-stop'
              "></i>
            </n-button>
            <n-button v-if="
              !IS_HEALTHKIT &&
              (vitalGroup && deviceforcard && deviceforcard.communication && deviceforcard.communication.fetchPerVital) &&
              connectedDevicesEnabled &&
              deviceforcard.communication.communicationType != 'MANUAL' &&
              deviceforcard.communication.communicationType != 'OCR' && allowRetrieval
            " type="primary" @click.native="addVitals()" social icon round style="position: absolute; top: -1em; inset-inline-end: -0.5em">
              <i class="fas fa-plus"></i>
            </n-button>
            <n-button type="primary" social icon round style="position: absolute; top: -1em; inset-inline-end: -0.5em" v-if="IS_HEALTHKIT && IS_IOS && connectedDevicesEnabled" @click.native="sync()">
              <i class="fas fa-sync"></i>
            </n-button>
            <n-button v-if="connectedDevicesEnabled && deviceforcard.communication.communicationType == 'OCR' && allowRetrieval" type="primary" @click.native="goToScan()" social icon round style="position: absolute; top: -1em; inset-inline-end: -0.5em">
              <i class="fa fa-camera-retro"></i>
            </n-button>

            <n-button type="primary" social icon round size="lg" @click.native="shareVitals(deviceforcard.identifier)" v-if="!IS_HEALTHKIT && user && (IS_NURSE || IS_PATIENT) && shareButton" style="margin: 10px;">
              <i class="fa fa-share-alt"></i>
            </n-button>

            <n-button type="primary" social icon round size="lg" @click.native="uploadVitals()" v-if="user && uploadButton" style="margin: 10px;">
              <i class="fas fa-cloud-upload-alt"></i>
            </n-button>
          </div>
          </div>
        </div>
      </div>
    </card>
    <modal :show.sync="showAddVitalsModel" headerClasses="justify-content-center" :showClose="true">
      <h4 slot="header" class="title title-up">Add Vitals</h4>
      <div class="col-12" v-if="showAddVitalsModel" style="padding: 0px;overflow: hidden scroll;height: 46em;">
        <add-vital :hide-save-button="true" ref="addVital"></add-vital>
      </div>
    </modal>
    <modal :show.sync="showScanOCRModal" headerClasses="justify-content-center" :showClose="true">
      <h4 slot="header" class="title title-up">Scan Vitals</h4>
      <div class="col-12" v-if="showScanOCRModal" style="padding: 0px;overflow: hidden scroll;height: 46em;">
        <scan-vital :do-not-route-back="true" @confirmed="showScanOCRModal=false"></scan-vital>
      </div>
    </modal>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { Select, Option } from "element-ui";
import { mapState } from "vuex";
import {
  vitalsFetch,
  syncAppleHealthKit,
  startVitalsMeasure,
  stopVitalsMeasure,
  disconnect,
} from "../../../utils/device.js";
import moment from "moment";
import { LineChart } from "src/components";
import { create, all } from "mathjs";
import addVital from "../../carenation/patient/AddVital.vue";
import scanVital from "../../carenation/nurse/ScanVital.vue";
const math = create(all, {});

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [LineChart.name]: LineChart,
    addVital,
    scanVital,
  },
  data() {
    return {
      vitalValue: "",
      vitalUnitSelect: "",
      color: null,
      IS_NURSE: false,
      IS_PATIENT: false,
      dataForGraph: {},
      showAddVitalsModel: false,
      showScanOCRModal: false,
    };
  },
  props: [
    "deviceforcard",
    "vitalIndex",
    "errorMessages",
    "historicVitals",
    "allowManualEntry",
    "allowRetrieval",
    "hideVitalHistory",
    "disableInputs",
    "shareVitals",
    "shareButton",
    "uploadButton",
    "vitals",
    "vitalGroupIdentifier",
    "vitalGroup",
  ],

  mounted() {
    this.IS_NURSE = this.user.roles.includes("nurse");
    this.IS_PATIENT = this.user.roles.includes("patient");
    //Getting color for chart from settings
    if (
      this.settings &&
      this.settings.theming &&
      this.settings.theming.telemed
    ) {
      let colors = this.settings.theming.telemed;
      colors.primaryColor && (this.color = colors.primaryColor);
    }
    this.setHistoricVitals();
  },
  methods: {
    async retrieveVital(device) {
      let that = this;

      if (device.communication.communicationMethod == "FETCH") {
        try {
          let response = await vitalsFetch(device);
          console.log(response);
          response.data.forEach((measuredVital) => {
            that.vitals.forEach((vital) => {
              if (vital.identifier == measuredVital.type) {
                let convertedVital = that.handleUnitConversion(vital.unit, {
                  name: measuredVital.type,
                  value: Number(measuredVital.value),
                  unit: measuredVital.unit,
                });

                if (convertedVital.value % 1 == 0) {
                  vital.value = convertedVital.value;
                } else {
                  vital.value = math.format(convertedVital.value, {
                    notation: "fixed",
                    precision: 2,
                  });
                }
                vital.unit.primary = convertedVital.unit;
                return;
              }
            });
          });
          console.log(JSON.stringify(device));
          that.showVitals = false;
          setTimeout(() => {
            that.showVitals = true;
          }, 100);
          that.$forceUpdate();
        } catch (err) {
          swal.fire({
            type: "error",
            title: that.$t("message.Error"),
            text: that.$t("message.Couldn't fetch vitals"),
          });
          console.log("Error fetching data from device", err);
        }
      } else if (device.communication.communicationMethod == "SYNC") {
        if (
          device.identifier == "AppleHealthKit" &&
          device.manufacturer == "apple" &&
          device.model == "applewatch7" &&
          device.type == "vitals" &&
          device.vitals
        ) {
          try {
            let response = await syncAppleHealthKit(device);
            response.data.forEach((measuredVital) => {
              that.vitals.forEach((vital) => {
                if (vital.identifier == measuredVital.type) {
                  let convertedVital = that.handleUnitConversion(vital.unit, {
                    name: measuredVital.type,
                    value: Number(measuredVital.value),
                    unit: measuredVital.unit,
                  });

                  if (convertedVital.value % 1 == 0) {
                    vital.value = convertedVital.value;
                  } else {
                    vital.value = math.format(convertedVital.value, {
                      notation: "fixed",
                      precision: 2,
                    });
                  }
                  vital.unit.primary = convertedVital.unit;
                  return;
                }
              });
            });
            console.log(JSON.stringify(device));
            that.showVitals = false;
            setTimeout(() => {
              that.showVitals = true;
            }, 100);
            that.$forceUpdate();
          } catch (err) {
            swal.fire({
              type: "error",
              title: that.$t("message.Error"),
              text: that.$t("message.Couldn't fetch vitals"),
            });
            console.log("Error syncing data from device", err);
          }
        }
      } else if (device.communication.communicationMethod == "NOTIFY") {
      } else if (device.communication.communicationMethod == "SCAN") {
      } else if (device.communication.communicationMethod == "MEASURE") {
        if (this.receiving) {
          this.receiving = false;
          stopVitalsMeasure(
            device,
            (response) => {
              console.log(response);
            },
            (err) => {
              console.log(err);
            }
          );
          if (this.response) {
            this.response.data.forEach((measuredVital) => {
              that.vitals.forEach((vital) => {
                if (vital.identifier == measuredVital.type) {
                  let convertedVital = that.handleUnitConversion(vital.unit, {
                    name: measuredVital.type,
                    value: Number(measuredVital.value),
                    unit: measuredVital.unit,
                  });

                  if (convertedVital.value % 1 == 0) {
                    vital.value = convertedVital.value;
                  } else {
                    vital.value = math.format(convertedVital.value, {
                      notation: "fixed",
                      precision: 2,
                    });
                  }
                  vital.unit.primary = convertedVital.unit;
                  return;
                }
              });
            });

            this.receiving = false;

            console.log(JSON.stringify(device));
            that.showVitals = false;
            setTimeout(() => {
              that.showVitals = true;
            }, 100);
            this.loader.hide();
            that.$forceUpdate();
          }
        } else {
          this.response = null;
          this.loader = this.$loading.show({
            // Optional parameters
            container: null,
            canCancel: false,
          });
          this.receiving = true;
          startVitalsMeasure(
            device,
            this.vitalToAdd || {
              identifier: that.$store.state.vitalGroupIdentifier,
            },
            (response) => {
              console.log(response);
              if (!this.continuousDevice) {
                response.data.forEach((measuredVital) => {
                  that.vitals.forEach((vital) => {
                    if (vital.identifier == measuredVital.type) {
                      let convertedVital = that.handleUnitConversion(
                        vital.unit,
                        {
                          name: measuredVital.type,
                          value: Number(measuredVital.value),
                          unit: measuredVital.unit,
                        }
                      );

                      if (convertedVital.value % 1 == 0) {
                        vital.value = convertedVital.value;
                      } else {
                        vital.value = math.format(convertedVital.value, {
                          notation: "fixed",
                          precision: 2,
                        });
                      }
                      vital.unit.primary = convertedVital.unit;
                      return;
                    }
                  });
                });

                disconnect(device);
                this.receiving = false;

                console.log(JSON.stringify(device));
                that.showVitals = false;
                setTimeout(() => {
                  that.showVitals = true;
                }, 100);
                this.loader.hide();
                that.$forceUpdate();
              } else {
                this.loader.hide();
                let vitalObj = this.vitalToAdd || {
                  identifier: that.$store.state.vitalGroupIdentifier,
                };
                if (response && response.data) {
                  this.response = response;
                } else if (
                  response &&
                  response.event &&
                  vitalObj &&
                  vitalObj.identifier &&
                  response.event.type == vitalObj.identifier &&
                  response.event.value == "readingEnd"
                ) {
                  this.retrieveVital(device);
                }
              }
            },
            (err) => {
              this.loader.hide();
              this.receiving = false;
              swal.fire({
                type: "error",
                title: that.$t("message.Error"),
                text: that.$t("message.Couldn't fetch vitals"),
              });
              console.log(err);
            }
          );
        }
      }
    },
    setHistoricVitals() {
      if (this.historicVitals) {
        this.dataForGraph = {};
        if (this.vitals && this.vitals.length) {
          this.vitals.forEach((deviceVital) => {
            this.dataForGraph[deviceVital.identifier] = {
              labels: [],
              datasets: [],
            };
            let data = [];
            if (
              this.historicVitals[deviceVital.identifier] &&
              this.historicVitals[deviceVital.identifier].length > 0
            ) {
              this.historicVitals[deviceVital.identifier].forEach((hv) => {
                data.push(hv.value);
                this.dataForGraph[deviceVital.identifier].labels.push(
                  this.getFormattedTime(hv.timestamp)
                );
              });
            }
            this.dataForGraph[deviceVital.identifier].datasets.push({
              label: deviceVital.displayName[this.$i18n.locale],
              data: data,
              borderColor: this.color,
              pointBorderColor: "#FFF",
              pointBackgroundColor: this.color,
              pointBorderWidth: 2,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 1,
              pointRadius: 4,
              fill: true,
              borderWidth: 2,
            });
          });
          this.$forceUpdate();
        }
      }
    },
    addVitals(vital) {
      let _vital = null;
      if (
        vital &&
        this.deviceforcard &&
        this.deviceforcard.communication &&
        this.deviceforcard.communication.fetchPerVital
      ) {
        _vital = vital;
      }
      this.$store.commit("setState", {
        stateName: "vitalToAdd",
        stateValue: _vital,
      });
      this.$store.commit("setState", {
        stateName: "deviceToAddVital",
        stateValue: this.deviceforcard,
      });
      this.$store.commit("setState", {
        stateName: "vitalsToAdd",
        stateValue: this.vitals,
      });
      this.$store.commit("setState", {
        stateName: "vitalGroupIdentifier",
        stateValue: this.vitalGroupIdentifier,
      });
      this.$store.commit("setState", {
        stateName: "errorMessages",
        stateValue: this.errorMessages,
      });
      this.showAddVitalsModel = true;
    },
    async sync() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      try {
        await syncAppleHealthKit(this.deviceforcard);
        console.log("Apple healthkit synced");
        swal.fire({
          type: "success",
          title: this.$t("message.Synced successfully!"),
          timer: 3000,
        });
        this.loader.hide();
      } catch (err) {
        swal.fire({
          type: "error",
          title: this.$t("message.Syncing failed!"),
          timer: 3000,
        });
        this.loader.hide();
        console.log(err);
      }
    },
    goToScan() {
      this.$store.commit("setState", {
        stateName: "deviceToScan",
        stateValue: this.deviceforcard,
      });
      this.showScanOCRModal = true;
    },
    getFormattedTime(time) {
      return moment(time).format("DD-MM-YYYY, hh:mm a");
    },
    async uploadVitals() {
      try {
        let vitals = {};
        this.vitals.forEach((vital) => {
          if (vital.value) {
            vitals[vital.identifier] = {
              name: vital.displayName[this.$i18n.locale],
              value: vital.value,
              unit: vital.unit.primary,
            };
          }
        });
        console.log(vitals);
        //Save only when object is not empty
        if (!$.isEmptyObject(vitals)) {
          //Save vitals to ES
          let vital = vitals;

          let vitalsData = [];

          //Generating vitals data object to save
          for (var vitalName in vital) {
            if (Number(vital[vitalName].value)) {
              vitalsData.push({
                patientId: this.$store.state.patient.patientId,
                value: Number(vital[vitalName].value),
                name: vitalName,
                unit: vital[vitalName].unit,
                provider: "manual",
              });
            }
          }

          await this.$store.dispatch("saveVitalsData", vitalsData);
          swal.fire({
            title: this.$t("message.Saved!"),
            type: "success",
            timer: 2000,
          });
          if (this.IS_PATIENT) {
            socket.emit("latestVitalsUpdate", {
              caregroupId: this.user.caregroup._id || this.user.caregroup,
              patientId: this.user.patientId,
            });
          }
        } else {
          swal.fire({
            title: this.$t("message.Cannot share vitals"),
            text: this.$t("message.Vitals are empty"),
            type: "info",
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          title: this.$t("message.Couldn't Share!"),
          type: "error",
          timer: 5000,
        });
      }
    },
    handleUnitConversion(unitMetadata, reading) {
      //reading.unit = reading.unit.toLowerCase();
      if (reading.unit == unitMetadata.primary) {
        return reading;
      }

      if (isNaN(reading.value)) {
        return reading;
      }

      if (unitMetadata.secondary) {
        var conversionStr = unitMetadata.secondary[reading.unit];
      } else {
        return reading;
      }

      if (!conversionStr) {
        return reading;
      }

      var conversionFunc = math.eval("f(x) = " + conversionStr);
      var convertedVal = conversionFunc(Number(reading.value));
      reading.value = convertedVal;
      reading.unit = unitMetadata.primary;

      return reading;
    },
  },
  computed: {
    ...mapState({
      activePatientVitals: (state) => state.activePatientVitals,
    }),
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    connectedDevicesEnabled() {
      return (
        this.$store.state.connectedDevices &&
        cordova &&
        cordova.plugins.CarenationDevicesPlugin
      );
    },
    IS_IOS() {
      return device.platform == "iOS";
    },
    IS_HEALTHKIT() {
      return (
        this.deviceforcard.identifier == "AppleHealthKit" &&
        this.deviceforcard.manufacturer == "apple" &&
        this.deviceforcard.model == "applewatch7" &&
        this.deviceforcard.type == "vitals"
      );
    },
  },

  watch: {
    historicVitals: function () {
      this.setHistoricVitals();
    },
    deviceforcard: function () {
      this.setHistoricVitals();
    },
  },
};
</script>
<style>
.vital-card {
  border-radius: 2rem;
}
.vital-image {
  margin-top: 3px;
  margin-left: 3px;
  height: 55px;
  width: 55px;
}

.device-vital-image {
  width: 3em;
  height: 3em;
  margin: 0;
  position: relative;
  top: 0.8em;
}
.el-select .el-input .el-input__inner {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  border-radius: 30px;
  color: black;
}
.has-success:after,
.has-danger:after {
  display: none;
}
.info-horizontal .icon.icon-circle {
  margin-top: 0px;
}
.vital-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(2);
}
.indicator svg polyline {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.indicator svg polyline#back {
  stroke: var(--color-primary) 8c;
}
.indicator svg polyline#front {
  stroke: var(--color-primary);
  stroke-dasharray: 12, 36;
  stroke-dashoffset: 48;
  animation: dash 1s linear infinite;
}
.cta {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 30px;
  color: #222;
  font-weight: bold;
}
@-moz-keyframes dash {
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash {
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@-o-keyframes dash {
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}
#chartjs-tooltip {
  transition: left 0.5s, top 0.5s;
  border-radius: 5px;
}

#chartj-span {
  height: 1em;
  width: 1em;
  display: inline-block;
  border: 1px solid white;
  margin-right: 5px;
  margin-top: 5px;
}
</style>
<style scoped>
.form-control[disabled] {
  background-color: transparent;
  color: #2c2c2c;
}
/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: transparent;
}

/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: 1px solid #e3e3e3;
}
/deep/ #add-vital {
  padding: 0px;
  padding-left: 0.3em;
}
</style>
